import { render, staticRenderFns } from "./FleetHealthReportCard.vue?vue&type=template&id=3c5d1cc5&scoped=true&"
import script from "./FleetHealthReportCard.vue?vue&type=script&lang=js&"
export * from "./FleetHealthReportCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5d1cc5",
  null
  
)

export default component.exports